import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Dialog from 'components/Dialog';
import ThemeGallery from 'components/ThemeGallery';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import mustache from 'mustache';
import {InvoiceTemplates as legacyThemes} from '../../config/invoice_templates';
import {GalleryTemplates, INDUSTRIES, DOCUMENT_TYPES} from '../../config/template_gallery';

function renderPreview(t) {
    try {
        const data = {
            seller: { ...t, company: 'Your Company', registrationNumber: '', address: { street: '', city: '', zip: '', country: '', region: '' }, phone: '', email: '', bank: { name: '', iban: '', currency: '', swift: '' }, logo: '' },
            buyer: { name: 'Client Name', notCompany: true, company: '', address: { street: '', city: '', zip: '', country: '' }, phone: '', email: '' },
            order: { order_number: '1001', shipping_address: { name: '', address1: '', city: '', province: '', zip: '', country: '' }, fulfillments: [] },
            invoice: { number: { series: '', id: '1001' }, date: '', taxes: { show: false }, currency: { main: 'USD' }, final: { price: '0.00' }, isCreditNote: false },
            description_rows: '',
            total: { main: '0.00' }
        };
        return mustache.render(t.bodyTemplate, data);
    } catch (e) {
        return t.bodyTemplate.replace(/\{\{\{[^}]+\}\}\}/g, '').replace(/\{\{[^}]+\}\}/g, '');
    }
}

class TemplateMarketDialog extends Dialog {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            selectedIndustry: null,
            selectedDocType: null,
            multiSelect: false,
            selectedTemplates: [],
            searchQuery: ''
        };
    }

    hide() {
        super.hide();
        if (this.props.onHide) this.props.onHide();
    }

    getFilteredTemplates() {
        const { selectedIndustry, selectedDocType, searchQuery } = this.state;
        let templates = [];

        if (!selectedIndustry) {
            templates = [...GalleryTemplates, ...legacyThemes];
        } else if (selectedIndustry === 'other') {
            templates = legacyThemes;
        } else {
            templates = GalleryTemplates.filter(t => t.industry === selectedIndustry || t.isUniversal);
        }

        if (selectedDocType) {
            templates = templates.filter(t => {
                if (selectedDocType === 'invoice') return t.documentType === 'invoice' && !t.name.toLowerCase().includes('receipt');
                if (selectedDocType === 'quote') return t.documentType === 'quote' || t.name.toLowerCase().includes('quote') || t.name.toLowerCase().includes('estimate') || t.name.toLowerCase().includes('engagement') || t.name.toLowerCase().includes('proposal');
                if (selectedDocType === 'receipt') return t.name.toLowerCase().includes('receipt');
                if (selectedDocType === 'credit-note') return t.documentType === 'credit-note' || t.name.toLowerCase().includes('credit');
                if (selectedDocType === 'packing-slip') return t.name.toLowerCase().includes('packing');
                if (selectedDocType === 'delivery-note') return t.name.toLowerCase().includes('delivery');
                if (selectedDocType === 'purchase-order') return t.name.toLowerCase().includes('purchase order');
                if (selectedDocType === 'proforma') return t.documentType === 'proforma' || t.name.toLowerCase().includes('proforma');
                if (selectedDocType === 'report') return t.documentType === 'report' || t.name.toLowerCase().includes('report');
                return true;
            });
        }

        if (searchQuery && searchQuery.trim()) {
            const q = searchQuery.toLowerCase().trim();
            templates = templates.filter(t =>
                (t.name && t.name.toLowerCase().includes(q)) ||
                (t.documentType && t.documentType.toLowerCase().includes(q)) ||
                (t.industry && t.industry.toLowerCase().includes(q)) ||
                (t.systemName && t.systemName.toLowerCase().includes(q))
            );
        }

        return templates;
    }

    toggleMultiSelect() {
        this.setState({ multiSelect: !this.state.multiSelect, selectedTemplates: [] });
    }

    toggleTemplate(name) {
        let { selectedTemplates } = this.state;
        if (selectedTemplates.includes(name)) {
            this.setState({ selectedTemplates: selectedTemplates.filter(n => n !== name) });
        } else {
            this.setState({ selectedTemplates: [...selectedTemplates, name] });
        }
    }

    selectAllInIndustry() {
        const templates = this.getFilteredTemplates();
        this.setState({ selectedTemplates: templates.map(t => t.name) });
    }

    render() {
        const { handleSubmit, theme, submitting } = this.props;
        const { selectedIndustry, selectedDocType, multiSelect, selectedTemplates } = this.state;
        let show = this.state.show;
        const filteredTemplates = this.getFilteredTemplates();

        return <Modal dialogClassName="download-orders-dialog market-dialog template-gallery-modal" enforceFocus={true} show={show || false} onHide={this.hide}>
            <form onSubmit={handleSubmit((values) => {
                if (multiSelect && selectedTemplates.length > 0) {
                    this.props.onOk({ themes: selectedTemplates });
                } else {
                    this.props.onOk(values);
                }
            })}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Template Gallery
                        <small style={{display:'block',fontSize:'12px',color:'#888',marginTop:'3px'}}>
                            Choose templates for your business
                        </small>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: 0 }}>
                    <style dangerouslySetInnerHTML={{__html:`
                    .template-gallery-modal .modal-dialog { width: 90%; max-width: 1200px; }
                    .template-preview { height: 521px; }
                    .industry-tabs { display: flex; flex-wrap: wrap; gap: 6px; padding: 15px 20px; border-bottom: 1px solid #eee; background: #fafafa; }
                    .industry-tab { padding: 6px 12px; border: 1px solid #ddd; border-radius: 20px; font-size: 12px; cursor: pointer; background: #fff; transition: all 0.15s; display: flex; align-items: center; gap: 5px; }
                    .industry-tab:hover { border-color: #0984e3; color: #0984e3; }
                    .industry-tab.active { background: #0984e3; color: #fff; border-color: #0984e3; }
                    .industry-tab .fa { font-size: 11px; }
                    .doctype-filters { display: flex; flex-wrap: wrap; gap: 5px; padding: 10px 20px; border-bottom: 1px solid #eee; }
                    .doctype-filter { padding: 4px 10px; border: 1px solid #ddd; border-radius: 3px; font-size: 11px; cursor: pointer; background: #fff; }
                    .doctype-filter:hover { border-color: #0984e3; }
                    .doctype-filter.active { background: #e3f2fd; border-color: #0984e3; color: #0984e3; }
                    .gallery-toolbar { display: flex; justify-content: space-between; align-items: center; padding: 8px 20px; border-bottom: 1px solid #eee; }
                    .gallery-toolbar .count { font-size: 11px; color: #888; }
                    .gallery-toolbar .actions { display: flex; gap: 8px; }
                    .gallery-toolbar .btn-sm { font-size: 11px; padding: 3px 8px; }
                    .template-gallery-content { padding: 15px 20px; }
                    .template-gallery-content .theme-gallery { height: auto; overflow: visible; display: flex; flex-wrap: wrap; }
                    .template-gallery-content .theme-gallery .theme-gallery-card { width: 570px; height: 600px; }
                    `}}></style>

                    <div className="industry-tabs">
                        <span
                            className={!selectedIndustry ? "industry-tab active" : "industry-tab"}
                            onClick={() => this.setState({ selectedIndustry: null, selectedDocType: null })}
                        >
                            <i className="fa fa-th"></i> All
                        </span>
                        {INDUSTRIES.map(ind => (
                            <span
                                key={ind.id}
                                className={selectedIndustry === ind.id ? "industry-tab active" : "industry-tab"}
                                onClick={() => this.setState({ selectedIndustry: ind.id, selectedDocType: null })}
                            >
                                <i className={`fa ${ind.icon}`}></i> {ind.name}
                            </span>
                        ))}
                    </div>

                    {selectedIndustry && selectedIndustry !== 'other' && <div className="doctype-filters">
                        <span
                            className={!selectedDocType ? "doctype-filter active" : "doctype-filter"}
                            onClick={() => this.setState({ selectedDocType: null })}
                        >All Types</span>
                        {DOCUMENT_TYPES.map(dt => (
                            <span
                                key={dt.id}
                                className={selectedDocType === dt.id ? "doctype-filter active" : "doctype-filter"}
                                onClick={() => this.setState({ selectedDocType: dt.id })}
                            >{dt.name}</span>
                        ))}
                    </div>}

                    <div className="gallery-toolbar">
                        <div style={{display:'flex',alignItems:'center',gap:'10px'}}>
                            <div style={{position:'relative'}}>
                                <i className="fa fa-search" style={{position:'absolute',left:'8px',top:'7px',fontSize:'11px',color:'#999'}}></i>
                                <input
                                    type="text"
                                    placeholder="Search templates..."
                                    value={this.state.searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                    style={{paddingLeft:'26px',fontSize:'12px',border:'1px solid #ddd',borderRadius:'4px',padding:'5px 10px 5px 26px',width:'200px',outline:'none'}}
                                />
                                {this.state.searchQuery && <i className="fa fa-times" style={{position:'absolute',right:'8px',top:'7px',fontSize:'11px',color:'#999',cursor:'pointer'}} onClick={() => this.setState({ searchQuery: '' })}></i>}
                            </div>
                            <span className="count">{filteredTemplates.length} template{filteredTemplates.length !== 1 ? 's' : ''}</span>
                        </div>
                        <div className="actions">
                            <button type="button" className={multiSelect ? "btn btn-primary btn-sm" : "btn btn-default btn-sm"} onClick={this.toggleMultiSelect.bind(this)}>
                                <i className="fa fa-check-square-o"></i> {multiSelect ? 'Multi-select ON' : 'Multi-select'}
                            </button>
                            {multiSelect && <button type="button" className="btn btn-default btn-sm" onClick={this.selectAllInIndustry.bind(this)}>
                                Select All
                            </button>}
                        </div>
                    </div>

                    <div className="template-gallery-content">
                        {multiSelect ? (
                            <div className="theme-gallery">
                                {filteredTemplates.map(t => (
                                    <div
                                        key={t.name}
                                        onClick={() => this.toggleTemplate(t.name)}
                                        className={selectedTemplates.includes(t.name) ? "theme-gallery-card selected" : "theme-gallery-card"}
                                    >
                                        <h4>{t.name}
                                            <small className="pull-right">{t.documentType || "all"}</small>
                                        </h4>
                                        {selectedTemplates.includes(t.name) && <span style={{position:'absolute',top:'8px',right:'8px',background:'#0984e3',color:'#fff',borderRadius:'50%',width:'20px',height:'20px',display:'flex',alignItems:'center',justifyContent:'center',fontSize:'11px'}}><i className="fa fa-check"></i></span>}
                                        <small className="moz-preview-not-available">Preview not avaiable for Firefox. Chrome browser is recommended.</small>
                                        <div className="theme-preview-wrapper" style={{position:'relative'}}>
                                            <iframe
                                                srcDoc={renderPreview(t)}
                                                style={{width:'250%',height:'1000px',border:'none',pointerEvents:'none',transform:'scale(0.4)',transformOrigin:'top left'}}
                                            />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        ) : (
                            <Field name="theme" selectedTheme={theme} themes={filteredTemplates} component={ThemeGallery} />
                        )}
                    </div>

                </Modal.Body>

                <Modal.Footer>
                    <Button type="button" className="pull-left" onClick={this.hide}>Cancel</Button>
                    {multiSelect && selectedTemplates.length > 0 && (
                        <Button type="submit" className="pull-left" bsStyle="primary" disabled={submitting}>
                            Install {selectedTemplates.length} template{selectedTemplates.length > 1 ? 's' : ''}
                        </Button>
                    )}
                    {!multiSelect && theme && <Button type="submit" className="pull-left" disabled={submitting || !theme} bsStyle="primary">Create</Button>}
                </Modal.Footer>
            </form>
        </Modal>
    }
}

TemplateMarketDialog = reduxForm({ form: "TemplateMarketDialog", destroyOnUnmount: false })(TemplateMarketDialog);
const selector = formValueSelector('TemplateMarketDialog');

TemplateMarketDialog = connect(state => {
    const theme = selector(state, 'theme');
    return {
        theme
    }
}, null, null, {
        withRef: true
    })(TemplateMarketDialog);
export default TemplateMarketDialog;



// WEBPACK FOOTER //
// app/containers/TemplateMarketDialog.jsx